import { html, type TemplateResult } from "lit";

// Inline single-path SVG icons used across the UI (design "Assets"). Strokes use
// currentColor so they inherit the surrounding text color; the official badge is a
// filled cyan seal with a brand-contrast check. Sizes are passed per call.

export const searchIcon = (size = 14): TemplateResult => html`<svg
  width=${size}
  height=${size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  aria-hidden="true"
>
  <circle cx="11" cy="11" r="7"></circle>
  <path d="M21 21l-4-4"></path>
</svg>`;

export const chevronDown = (size = 12): TemplateResult => html`<svg
  width=${size}
  height=${size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2.4"
  aria-hidden="true"
>
  <path d="M6 9l6 6 6-6"></path>
</svg>`;

export const copyIcon = (size = 14): TemplateResult => html`<svg
  width=${size}
  height=${size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  aria-hidden="true"
>
  <rect x="9" y="9" width="11" height="11" rx="2"></rect>
  <path d="M5 15V5a2 2 0 0 1 2-2h10"></path>
</svg>`;

export const downloadIcon = (size = 11): TemplateResult => html`<svg
  width=${size}
  height=${size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2.2"
  aria-hidden="true"
>
  <path d="M12 3v12m0 0l-5-5m5 5l5-5M5 21h14"></path>
</svg>`;

export const trendUp = (size = 12): TemplateResult => html`<svg
  width=${size}
  height=${size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2.4"
  aria-hidden="true"
>
  <path d="M7 17L17 7M7 7h10m0 0v10"></path>
</svg>`;

export const trendDown = (size = 12): TemplateResult => html`<svg
  width=${size}
  height=${size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2.4"
  aria-hidden="true"
>
  <path d="M7 7l10 10M17 17H9m8 0V9"></path>
</svg>`;

// Official-publisher seal: a star-burst filled with --brand and a --brand-contrast check.
export const officialBadge = (size = 13): TemplateResult => html`<svg
  width=${size}
  height=${size}
  viewBox="0 0 24 24"
  fill="none"
  style="flex-shrink:0"
  role="img"
  aria-label="official"
>
  <path
    d="M12 2l2.4 1.8 3-.2 1 2.8 2.6 1.5-1 2.8 1 2.8-2.6 1.5-1 2.8-3-.2L12 22l-2.4-1.8-3 .2-1-2.8L3 16.3l1-2.8-1-2.8 2.6-1.5 1-2.8 3 .2z"
    style="fill:var(--brand)"
  ></path>
  <path
    d="M8.5 12l2.3 2.3 4.7-4.7"
    fill="none"
    style="stroke:var(--brand-contrast)"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  ></path>
</svg>`;
